<template>
  <div>
    <van-popup v-model="show" :close-on-click-overlay="false">
      <template>
        <div class="content">
          <van-loading size="45" type="spinner" color="rgb(13 208 58)" />
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: true
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, 0);
}
.van-popup {
  background: rgba(0, 0, 0, 0.6);
  width: 100px;
  height: 60px;
  border-radius: 20px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
